export default "__VITE_ASSET__BlR9bG_o__"